/**
 * Ảnh sản phẩm + Mô tả sản phẩm của HSNL NCC.
 *
 * Hai API chi tiết của KIOS (quick-search `supplier_profiles/{id}` và trước đây cả TPAT
 * `customer-profiles/{kh}/supplier-profiles/{ma}`) không trả `image`/`description`.
 * TPAT: backend ghép hai trường này từ API danh sách vào response chi tiết.
 * Quick Search: vẫn lưu khi bấm xem ở danh sách, trang chi tiết đọc localStorage
 * (còn sống sau khi refresh). Lưu theo cả id lẫn mã CĐS.
 */
const KEY = 'supplier-extras';
const MAX = 50;

export interface SupplierExtras {
  image?: string | null;
  description?: string | null;
  typeName?: string | null;
}

type Store = Record<string, SupplierExtras>;

const read = (): Store => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '{}') as Store;
  } catch {
    return {};
  }
};

export const saveSupplierExtras = (s: {
  id?: string | number | null;
  operationCode?: string | null;
  image?: string | null;
  description?: string | null;
  typeName?: string | null;
}): void => {
  try {
    const store = read();
    const value: SupplierExtras = {
      image: s.image,
      description: s.description,
      typeName: s.typeName,
    };
    const keys = [s.id, s.operationCode].filter((k) => k != null && k !== '').map(String);
    if (keys.length === 0) return;

    keys.forEach((k) => {
      const existing = Object.keys(store);
      if (existing.length >= MAX && !store[k]) {
        delete store[existing[0]]; // bỏ bản ghi cũ nhất
      }
      store[k] = value;
    });
    localStorage.setItem(KEY, JSON.stringify(store));
  } catch {
    /* localStorage đầy/không dùng được → bỏ qua, khối ảnh/mô tả chỉ trống chứ không vỡ trang */
  }
};

/** Đọc theo mã CĐS trước rồi tới id — chỗ gọi truyền cả hai, khoá nào có thì dùng. */
export const getSupplierExtras = (
  ...keys: Array<string | number | null | undefined>
): SupplierExtras => {
  const store = read();
  for (const k of keys) {
    if (k == null || k === '') continue;
    const hit = store[String(k)];
    if (hit) return hit;
  }
  return {};
};
